<script setup>
import EyeIcon from '@iconify-vue/ph/eye';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DataTableLayout from '@js/components/tables/DataTableLayout.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import HeaderCell from '@js/components/tables/cells/HeaderCell.vue';
import LinkCell from '@js/components/tables/cells/LinkCell.vue';
import NumberCell from '@js/components/tables/cells/NumberCell.vue';
import { useDataTable } from '@js/utils/dataTable';
import { useRoute } from '@js/utils/route';
import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue';

const { type } = defineProps({
    type: {
        type: String,
        required: false,
    },
});

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
    loading,
    table,
    count,
    globalFilter,
    filters,
    availableFilters,
    setGlobalFilter,
    setFilters,
} = useDataTable({
    columns: [
        columnHelper.accessor(() => null, {
            id: 'name',
            header: () => 'Nom',
            cell: (props) =>
                h(LinkCell, {
                    text: props.row.original.name,
                    href: route(
                        'front.projectManagement.sea.planningKeywords',
                        {
                            tenant: props.row.original.id,
                        },
                    ),
                    inertia: true,
                }),
        }),
        columnHelper.accessor(() => null, {
            id: 'keywords',
            header: () => 'Mots-clés',
            cell: (props) =>
                h(NumberCell, {
                    number: props.row.original.keywords,
                }),
        }),
        columnHelper.display({
            id: 'actions',
            headerCustom: true,
            header: (props) =>
                h(HeaderCell, {
                    header: props.header,
                    title: 'Actions',
                    width: 0,
                }),
            cell: (props) =>
                h(
                    BaseCell,
                    {},
                    {
                        default: () =>
                            h(ActionButton, {
                                size: 'small',
                                square: true,
                                title: 'Voir',
                                href: route(
                                    'front.projectManagement.sea.planningKeywords',
                                    {
                                        tenant: props.row.original.id,
                                    },
                                ),
                                icon: EyeIcon,
                            }),
                    },
                ),
        }),
    ],
    url: route('front.projectManagement.sea.postPlanningKeywords'),
    columnPinning: {
        right: ['actions'],
    },
});
</script>

<template>
    <DataTableLayout
        :table="table"
        :count="count"
        :global-filter="globalFilter"
        :filters="filters"
        :available-filters="availableFilters"
        :set-filters="setFilters"
        :set-global-filter="setGlobalFilter"
        :loading="loading"
    />
</template>
